import { Slide } from '@/components/core/Slide';
import videoFile from './21-architect-plan.webm';
import audioFile from './21-generative-design.mp3';

const autoNextDuration = 39000;
const transcript = `
  Kijk... hoe razendsnel ik ontwerpen of bouwtekeningen kan maken, mits ik goed getraind ben op de juiste data.

  Een architect of technisch tekenaar kan mij een beschrijving geven van wat nodig is, en binnen seconden 
  genereer ik verschillende ontwerpopties die als startpunt kunnen dienen.

  Dit versnelt het ontwerpproces enorm en stelt professionals in staat om meer tijd te besteden aan 
  het verfijnen en verbeteren van het ontwerp, in plaats van te beginnen vanaf een leeg vel.

  Natuurlijk is menselijke expertise nog steeds essentieel voor het controleren en aanpassen van deze 
  ontwerpen, maar de initiële creatieve fase kan aanzienlijk worden versneld.
`;

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      autoNext={autoNextDuration}
      transition="fade"
      background={{
        video: videoFile,
      }}
    >
      <div></div>
    </Slide>
  );
};
